import React, { useState, useEffect } from 'react'
import { NumericInput, Intent } from '@blueprintjs/core'

export const InputField = ({ type, maximum = 100 }) => {
    const [output, setOutput] = useState([])

    useEffect(() => {
        renderInputField()
    }, [])

    const renderInputField = (_) => {
        if (type == 'integer') {
            const props = {
                allowNumericCharactersOnly: true,
                buttonPosition: 'right',
                disabled: false,
                fill: false,
                intent: Intent.NONE,
                large: false,
                majorStepSize: 10,
                max: maximum,
                min: 0,
                minorStepSize: 0.1,
                selectAllOnFocus: false,
                selectAllOnIncrement: false,
                stepSize: 1,
                value: '',
            }
            setOutput([<NumericInput key={type} {...props} />])
        } else if (type == 'decimal') {
        } else if (type == 'months') {
        }
    }

    return output
}
